module.exports = __webpack_public_path__ + "media/images/icons/download_invite-d86d8e50f89a696d59344f40a22aa5b7.svg";